import PropTypes from 'prop-types'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem, Link } from '@domain-group/suit-theme'

import useAgencyProvider from '@hooks/useAgencyProvider'
import useCurrentUser from '@hooks/useCurrentUser'
import { generateUrls as generateProviderUrls } from '@hooks/useProvider'
import { generateUrls as generateProviderPriceListUrls } from '@hooks/useProviderPriceList'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import { confirmDelete } from '@functions/entity'

import type { AgencyProviderModel } from '@models/agencyProvider'

interface AgencyProviderProps {
  agencyProvider: AgencyProviderModel,
}

const AgencyProvider = (props: AgencyProviderProps) => {
  const { agencyProvider: initAgencyProvider } = props

  const { isAdmin } = useCurrentUser()

  const {
    agencyProvider: {
      identity_code,
    },
    callbacks: {
      createOrEditAgencyProvider,
      deleteAgencyProvider: deleteFn,
    },
    provider,
    providerPriceList,
  } = useAgencyProvider(initAgencyProvider)

  // @ts-expect-error TS2339
  const { title: providerTitle } = provider

  // @ts-expect-error TS2339
  const { editProviderUrl } = generateProviderUrls({ id: provider.id })
  // @ts-expect-error TS2339
  const { editProviderPriceListUrl } = generateProviderPriceListUrls({ id: providerPriceList.id })

  // @ts-expect-error TS2339
  const { id, title: providerPriceListTitle } = providerPriceList

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    strings: {
      confirmString: 'Are you sure?',
      deleteString: 'Remove',
      entityName: 'Provider',
    },
  }

  return (
    <DashboardModuleListItem
      boxProps={{ paddingX: 0 }}
      secondaryText={
        id && isAdmin ? (
          <Link
            greyLink
            href={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
          >
            {providerPriceListTitle}
          </Link>
        ) : providerPriceListTitle || 'Default Price List'
      }
      title={providerTitle}
    >
      {!!identity_code && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.TertiaryText>
          {identity_code}
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      )}

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            marginRight="medium"
            onClick={() => createOrEditAgencyProvider()}
            type="edit"
          />

          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            marginRight="medium"
            // @ts-expect-error TS2345
            onClick={() => confirmDelete(confirmDeletePayload)}
            type="delete"
          />

          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            href={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      </ScopedConditionalContent>
    </DashboardModuleListItem>
  )
}
AgencyProvider.propTypes = {
  agencyProvider: PropTypes.object,
}

export default AgencyProvider
